export default __webpack_public_path__ + "static/media/2.bcf7ea2d.png";